import { Visa, Mastercard, Paypal } from 'react-svg-credit-card-payment-icons/icons/flat-rounded';

const PaymentLogos = () => {
  return (
    <div className="space-y-3">
      <div className="text-xs md:text-sm text-muted-foreground text-center font-medium">
        Sichere Zahlung mit:
      </div>
      <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
        {/* PayPal */}
        <div className="h-12 md:h-14 transition-transform hover:scale-105">
          <Paypal width={70} />
        </div>

        {/* Visa */}
        <div className="h-12 md:h-14 transition-transform hover:scale-105">
          <Visa width={70} />
        </div>

        {/* Mastercard */}
        <div className="h-12 md:h-14 transition-transform hover:scale-105">
          <Mastercard width={70} />
        </div>

        {/* Klarna - Text Badge */}
        <div className="h-12 md:h-14 px-5 bg-gradient-to-r from-[#FFB3C7] to-[#FFD4E0] rounded-xl shadow-sm flex items-center justify-center transition-transform hover:scale-105">
          <span className="text-lg font-bold text-black" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>Klarna</span>
        </div>

        {/* Apple Pay & Google Pay - Combined Badge */}
        <div className="h-12 md:h-14 px-5 bg-gradient-to-r from-gray-900 to-gray-800 rounded-xl shadow-sm flex items-center gap-2 transition-transform hover:scale-105">
          <span className="text-lg font-semibold text-white">Pay</span>
          <div className="flex flex-col text-[10px] leading-tight text-gray-300">
            <span>Apple</span>
            <span>Google</span>
          </div>
        </div>
      </div>
      <div className="text-xs text-center text-muted-foreground">
        SSL-verschlüsselt • DSGVO-konform • 14 Tage Geld zurück
      </div>
    </div>
  );
};

export default PaymentLogos;
